import type { ReactElement } from 'react';
import { Badge } from '@/components/ui/badge';

export function SourceBadges({ sources }: { sources: string[] }): ReactElement {
  return (
    <div className="flex flex-wrap gap-1">
      {sources.map(source => (
        <Badge key={source} variant="secondary" className="text-xs">
          {source}
        </Badge>
      ))}
    </div>
  );
}
